/*  MUI  */
import { Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';
import { getScoreFillColor } from 'application/Shared/Reports/ScoreFillColor';

/*  React  */
import React from 'react';

export const QBRScoreChip = ({ score, renderType }) => {
    const theme = useTheme();
    let style = {
        backgroundColor: getScoreFillColor({ theme, value: score })
    };

    switch (renderType) {
        case 'inline':
            style.marginBottom = '5px';
            break;
        case 'saasHealthHeader':
            style = { ...style, fontSize: FontSizes[1] };
            break;
        case 'standalone':
            style.float = 'right';
            break;
        default:
            style.marginLeft = '10px';
            break;
    }

    return (
        <Chip
            label={
                <Typography color="text.black" fontWeight={700}>
                    {score}
                </Typography>
            }
            sx={style}
            variant="blackText"
        />
    );
};
